import React, { useContext, useEffect } from 'react'
import ContactImg from "../../components/condactForm/contact"
import { contextData } from '../../App'

function ContactPage() {

  const {isScrolled,setIsScrolled} = useContext(contextData);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsScrolled(true)
    return () => {
      setIsScrolled(false)
    }
  },[])

  return (
    <div className='pt-[114px]'>
      <ContactImg/>
    </div>
  )
}

export default ContactPage
